module.exports = __webpack_public_path__ + "img/alert_icon.ee4f8407.svg";